import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiKeysService } from '../../../api/services';
import { validateAllFormFields } from '../../../formUtils';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiKeys } from '../../../api/models';

@Component({
  selector: 'app-api-keys',
  templateUrl: './api-keys.component.html',
  styleUrl: './api-keys.component.css'
})
export class ApiKeysComponent {
    keysForm: FormGroup;
    keys: any

    constructor(private fb: FormBuilder,
        private apiKeysService: ApiKeysService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
) {
        this.keysForm = fb.group({
            'name': new FormControl(null, Validators.required)
      })



      this.keys=this.getKeys()

    }
    getKeys(): any {

        return this.apiKeysService.apiKeysGetAllKeys();

    }
    save() {


        if (this.keysForm.invalid) {

            validateAllFormFields(this.keysForm);
            return;
        }
        
        this.apiKeysService.apiKeysCreateKey({
            body: this.keysForm.value
        }).subscribe(_ => {

            this.messageService.add({
                key: 'alertToast',
                severity: 'success',
                summary: 'Success',
                detail: 'Key Created Successfully',
            })
            this.keys = this.getKeys();
            this.keysForm.reset();

        })


    }

    delete(apiId: number) {



        this.confirmationService.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to Delete this key?',
            accept: () => {
                this.apiKeysService.apiKeysDelete({

                    id: apiId
                }).subscribe(_ => {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Key Deleted Successfully',
                    })

                    this.keys = this.getKeys()

                })
            },
        })



      
    }

}
